var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-wrap"},[_c('img',{attrs:{"src":require("../assets/img/logo.png"),"alt":"","align":"absmiddle"},on:{"click":_vm.getClickRouter}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }